import React, { useState, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Col, Row } from "react-bootstrap"
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material"
import { Formik } from "formik"

import SubButtonNav from "components/SubMenuNavButton"
import ServiceCategoryModal from "./ServiceCategoryModal"

import { hotelAction } from "redux/hotel/slice/user"
import { createHotelNestedCategoryAction } from "redux/hotel/action"
import { validationSchemaCategoryModal } from "helpers/validationSchema"

import PlusIcon from "assets/icons/Plus.svg"
import styles from "../hotel.module.scss"

const SubCategoryNavBar = ({ activeTab, isEdit, navBarList }) => {
  const dispatch = useDispatch()
  const { linkCategory, linkNestedCategory } = useSelector((state) => state.hotel || {})
  const [categoryModal, setCategoryModal] = useState(false)

  const handleChange = (event) => {
    dispatch(hotelAction.setCategoryListValue(event.target.value))
  }

  const handleButtonNav = useCallback(
    (item) => {
      dispatch(
        hotelAction.setHotelNestedCategoryLink({
          ...item,
          list: isEdit ? "Detailed View" : "Summary View"
        })
      )
    },
    [isEdit]
  )

  const handleCloseModal = useCallback(() => {
    setCategoryModal(false)
  }, [])

  const handleSubmitCategory = useCallback(
    (values) => {
      const payload = {
        name: values?.category,
        subcategory_id: linkCategory?.id
      }
      dispatch(
        createHotelNestedCategoryAction({
          payload,
          onClose: handleCloseModal
        })
      )
    },
    [dispatch, linkCategory?.id, handleCloseModal]
  )

  return (
    <>
      <Formik
        initialValues={{ category: "" }}
        validationSchema={validationSchemaCategoryModal}
        enableReinitialize
        onSubmit={handleSubmitCategory}>
        {(formik) => (
          <ServiceCategoryModal
            open={categoryModal}
            onClose={handleCloseModal}
            isEdit={isEdit}
            formik={formik}
            title="Add New Nested Sub Category"
          />
        )}
      </Formik>

      {navBarList?.map((item) => (
        <SubButtonNav
          key={item?.id}
          style={{ marginRight: 12 }}
          onPress={() => handleButtonNav(item)}
          isActive={activeTab === item?.id}>
          {item?.name}
        </SubButtonNav>
      ))}
      {!isEdit && (
        <img
          src={PlusIcon}
          alt="add"
          className={styles.editIcon}
          onClick={() => setCategoryModal(true)}
        />
      )}

      {!isEdit && (
        <Row className="mt-1">
          <Col lg={12}>
            <FormControl variant="filled">
              <RadioGroup
                row
                aria-labelledby="category-view-toggle"
                name="category-view-toggle"
                value={linkNestedCategory?.list}
                onChange={handleChange}>
                <FormControlLabel
                  value="Summary View"
                  control={<Radio color="secondary" />}
                  label="Summary View"
                />
                <FormControlLabel
                  value="Detailed View"
                  control={<Radio color="secondary" />}
                  label="Detailed View"
                />
              </RadioGroup>
            </FormControl>
          </Col>
        </Row>
      )}
    </>
  )
}

export default SubCategoryNavBar
